import * as actionTypes from "./actionTypes";

export const setSignupInfo = signUpData => {
  return {
    type: actionTypes.STORE_SIGNUP_INFO,
    signUpData: signUpData
  };
};


export const setSignupModalStatus = (status, requestedForm = "signin") => {
  return {
    type: actionTypes.STORE_SIGNUP_STATUS,
    signUpModalStatus: status,
    signUpModalRequestedForm: requestedForm
  };
};
